import type { RouterConfig } from '@nuxt/schema'

export default <RouterConfig>{
  scrollBehavior(to, _from, savedPosition) {
    // Smooth-scroll pages: Lenis owns all scrolling including hash navigation.
    // Return false so Vue Router doesn't fight Lenis — afterEach in the plugin
    // handles both scroll-to-top and scroll-to-hash.
    if (to.meta.smoothScroll) {
      return false
    }
    // Default behaviour for the rest of the app.
    if (savedPosition) return savedPosition
    if (to.hash) return { el: to.hash, top: 0 }
    return { left: 0, top: 0, behavior: 'smooth' }
  },
}
